import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpsertSiteDailyReportMutation } from '../../../../hooks/mutations/useSiteDailyReportMutation';
import { SiteDailyReport } from '../../../../services/apiSLTP/dailyReports/siteDailyReports';
import CustomTextInput from '../../../CustomTextInput';
import ModalBody, { ModalProps } from '../../ModalBody';

interface ManageValidationDailyObservationsModalProps extends ModalProps {
    refetch: () => void;
    siteDailyReport?: SiteDailyReport | null;
    siteName?: string;
    date?: string;
    siteId?: string;
}

const ManageValidationDailyObservationsModal: React.FC<ManageValidationDailyObservationsModalProps> = ({
    open,
    handleClose,
    refetch,
    siteDailyReport,
    siteName,
    date,
    siteId,
}) => {
    const { t } = useTranslation();

    const [globalObservations, setGlobalObservations] = useState(siteDailyReport?.globalObservations || '');

    const { mutate: upsertSiteDailyReport } = useUpsertSiteDailyReportMutation({
        onSuccess: () => {
            refetch();
            handleClose();
        },
    });

    return (
        <ModalBody
            closeText={t('cancel')}
            title={t('observations')}
            subTitle={t('update')}
            description={siteName}
            okText={t('validate')}
            open={open}
            handleClose={handleClose}
            handleOk={() => {
                
                upsertSiteDailyReport({
                    date: siteDailyReport?.date || date || '',
                    siteId: siteDailyReport?.siteId._id || siteId || '',
                    globalObservations: globalObservations,
                });
            }}
            disabledOk={globalObservations.trim() === siteDailyReport?.globalObservations?.trim()}
        >
            <CustomTextInput value={globalObservations} onChange={setGlobalObservations} label={`${t('')}`} multiline />
        </ModalBody>
    );
};

export default ManageValidationDailyObservationsModal;
